/* eslint-disable */
import axios from 'axios'
import config from '@/config'
import {isFailed, axiosWrapper} from '@/shared/api.utils'
import {findInObject} from '@/utils/i18n'

function slugifySettingsDict(data) {
  let result = {}
  for (let sectionName in data) {
    for (let settingName in data[sectionName]) {
      let settingObject = data[sectionName][settingName]
      let sectionSlug = settingObject.section.slug
      let settingSlug = settingObject.slug
      if (!(sectionSlug in result)) {
        result[sectionSlug] = {}
      }
      let settingValue = settingObject.overridden ? settingObject.overridden.value : settingObject.default
      result[sectionSlug][settingSlug] = settingValue
    }
  }
  return result
}

function findSettingById(all, settingId) {
  for (let sectionName in all) {
    for (let settingName in all[sectionName]) {
      if (all[sectionName][settingName].id === settingId) {
        return all[sectionName][settingName]
      }
    }
  }
  return null
}

const settingsModule = {
  namespaced: true,
  state: {
    all: null,
    slugified: null,
    // which company `all` was loaded for. A save commits after its round trip, by which time a
    // different company may be loaded -- or the same one may have been refetched into entirely
    // new objects -- so the commit has to know what it is looking at.
    companyId: null
  },
  mutations: {
    updateToken (state, payload) {
      if (payload) {
        localStorage.setItem(tokenKey, payload)
        state.token = payload
      } else {
        localStorage.removeItem(tokenKey)
        state.token = null
      }

    },
    updateSettings(state, payload) {
      state.all = payload.settings
      state.companyId = payload.companyId
      state.slugified = slugifySettingsDict(payload.settings)
    },
    applySingleSettingValue(state, payload) {
      // Find the setting that is loaded *now*, by id, rather than mutating the object the request
      // captured when it started. Reopening a company refetches into brand new objects, so the
      // captured one can be an orphan: mutating it leaves state.all -- and slugified, which every
      // getSetting consumer reads -- showing the old value while the server holds the new one.
      if (payload.companyId !== state.companyId) {
        // a different company is loaded; its collection is not ours to touch, and the one this
        // save belongs to will be refetched whenever somebody opens it
        return
      }
      let setting = findSettingById(state.all, payload.setting.id)
      if (!setting) {
        return
      }
      if (setting.overridden) {
        setting.overridden.value = payload.newValue
      }
      setting.default = payload.newValue
      state.slugified = slugifySettingsDict(state.all)
    }
  },
  actions: {
    // set_carrier_setting can refuse a value -- it rejects anything outside the range a setting
    // declares in its metadata -- so wait for the answer before touching local state. This used to
    // be a mutation that fired the request and updated the store regardless, which showed a
    // refused value as saved while the database kept the old one.
    async updateSingleSetting(context, payload) {
      if (payload.newValue === payload.oldValue) {
        // do not send extra request
        return
      }

      let dataToSend = {
        token: localStorage.carrierToken,
        id: payload.setting.id,
        value: payload.newValue
      }

      await axiosWrapper(
        axios.post(`${config.url}/company/${payload.companyId}/set_carrier_setting/`, dataToSend))

      context.commit('applySingleSettingValue', payload)
    },
    load: function (context, payload) {
      console.log('Loading settings...')
      return new Promise((resolve, reject) => {
        let data
        let url
        url = config.url
        data = {
          token: localStorage.carrierToken
        }
        let promise = axios.post(`${config.url}/company/${payload.companyId}/get_carrier_settings/`, data)

        promise.then((response) => {
          if (isFailed(response)) {
            reject(response)
            return
          }

          // success
          context.commit('updateSettings',
                         {settings: response.data.data, companyId: payload.companyId})

          resolve(response)
        })
        promise.catch((e) => {
          reject(e)
        })
      })
    },
    init: function (context, payload) {
      let token = context.state.token
      return new Promise((resolve) => { //after login init done resolve promise in ANY case
          axios.post(config.url + '/get_carrier_user/', { //recheck token
            token,
          }).then(
            (response) => {
              if (isFailed(response)) {
                context.commit('updateToken', null)
              }

              context.commit('updateUser', response.data.data)
              resolve()
            },
            (response) => {
              context.commit('updateToken', null)
              resolve()
            },
          )
      })
    },
  },
  getters: {
    getSetting: (state) => (path, args) => {
      let [found, setting] = findInObject(state.slugified, path)
      return found ? setting : null
    },
  },
}

export default settingsModule
